import { Component, computed, inject, input } from '@angular/core';
import { Location } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

/**
 * "Page not found" (404) page, meant for the router's `**` wildcard in place of the silent
 * redirect to the dashboard. Shows the address that failed and offers Dashboard / Go back.
 */
@Component({
  selector: 'pm-not-found-page',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './pm-not-found-page.component.html',
  styleUrl: './pm-not-found-page.component.css'
})
export class PmNotFoundPageComponent {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  /** Overrides the address shown (used by /preview); defaults to the URL that was requested. */
  readonly requestedPath = input<string | null>(null);

  readonly shownPath = computed(() => this.requestedPath() ?? this.router.url);

  goBack(): void {
    // No in-app history (link opened directly / new tab) → fall back to the dashboard.
    if (window.history.length > 1) {
      this.location.back();
    } else {
      void this.router.navigateByUrl('/dashboard');
    }
  }
}
